import React, { useEffect, useState } from 'react'
import './edit.scss'
import Sidebar from '../../../components/sidebar/Sidebar'
import Navbar from '../../../components/navbar/Navbar'
// import Chart from '../../../components/chart/Chart'
import { doc, getDoc, onSnapshot, collection, query, where, getDocs, updateDoc, serverTimestamp, arrayRemove } from "firebase/firestore"
import { useNavigate, useParams } from "react-router-dom"
import { db, storage } from '../../../firebase'
import { Box, Breadcrumbs, Button, FormControl, InputLabel, MenuItem, Select, TextField, Typography, OutlinedInput, Chip } from '@mui/material'
import Link from '@mui/material/Link';


const roles = [

  { id:0, label: 'Admin', value: 'admin' },

  { id:1, label: 'Sub Admin', value: 'subadmin' },

  { id:2, label: 'Agency', value: 'agency' },

];


const Edit = () => {

  const {settingsId} = useParams()

  const [ settingsData, setSettingsData ] = useState([])


    const [firstname, setFirstname] = useState("")
    const [lastname, setLastname] = useState("")
    const [email, setEmail] = useState("")
    const [telephone, setTelephone] = useState("")
    const [role, setRole] = useState("")
    const [firstnameerror, setFirstnameerror] = useState("")
    const [lastnameerror, setLastnameerror] = useState("")
    const [emailerror, setEmailerror] = useState("")
    const [roleerror, setRoleerror] = useState("")
    const [telephoneerror, setTelephoneerror] = useState("")

    
    const [isloading, setIsloading] = useState(false)



const navigate = useNavigate()


  const getAdmin = async() => {

      const docRef = doc(db, "admins", settingsId);

      const docSnap = await getDoc(docRef);

    
      
      if (docSnap.exists()) {

        setSettingsData(docSnap.data())
        setFirstname(docSnap.data().firstname)
        setLastname(docSnap.data().lastname)
        setEmail(docSnap.data().email)
        setRole(docSnap.data().role)
        setTelephone(docSnap.data().telephone)

      
      } else {

        console.log("No such document!");

      }
  }

  useEffect(()=>{

    getAdmin()

  }, [])







  const handleUpdateAdmin = async() => {

  
      if(firstname === "") {

        return setFirstnameerror('firstname is required')
        
      }

      if(lastname === "") {

        return setLastnameerror('lastname is required')
      
      }

      if(telephone === "") {

        return setTelephoneerror('lastname is required')
      
      }

      if(role === "") {

        return setRoleerror('role is required')
        
      }

     

        setIsloading(true)

        try {
    
            // const docRef = await addDoc(collection(db, "subscribers"), {
            await updateDoc(doc(db, "admins", settingsId), {
    
              firstname : firstname,
              lastname : lastname,
              telephone : telephone,
              role : role,
              updatedAt: new Date(),
    
            })


           setIsloading(false)

           navigate('/settings')

                     
        } catch (error) {
    
          console.log(error.message);

          setIsloading(false)

        }
    
    
       
      }
 

  return (

       <div className="new">
          <Sidebar/>
          <div className="newContainer">
          <Navbar/>
            <div className='top'>
              <div className='topLeft'><h1>Edit Chillaxia Admin</h1></div>
              
              <div className='topRight'>
              <Breadcrumbs aria-label="breadcrumb">
                <Link underline="hover" color="inherit" href="/">
                  Home
                </Link>
                <Link
                  underline="hover"
                  color="inherit"
                  href="/settings"
                >
                  Admin List
                </Link>
                <Typography color="green">Edit Details</Typography>
              </Breadcrumbs>
              </div>
            </div>
             <div>
                  {/* <span>{message}</span> */}
                </div>
            <div className='top'>
             
               
                <div className="left">
    
                  
                   {/* <span style={{color:'red', fontSize:14}}>{error && 'Email already exist'}</span> */}
    
                <div className='form'  >
                {/* <div className='formInput' > */}
    
    
                   
                      <div style={{display: 'flex', flexDirection:'column', gap:10, width:'49%', marginBottom:20, marginRight:20}}>
    
                      <TextField
                        id="Email"
                        onChange={(e) => setEmail(e.target.value)}
                        value = {email}
                        placeholder="Enter Email"
                        type="email"
                        disabled={true}
                        style={{width:'100%'}}
                      />
    
                      {emailerror &&
                      <p style={{color:'red', fontSize:10, marginVertical:5}}> {emailerror}</p>
                      }
                
    
                      </div>
                 
                    <div style={{display: 'flex', flexDirection:'column', gap:10, width:'49%', marginBottom:20}}>
    
                    <TextField
                      id="firstname"
                      onChange={(e) => setFirstname(e.target.value)}
                      value = {firstname}
                      placeholder="Enter Firstname"
                      style={{width:'100%'}}
                    />
    
                    {firstnameerror &&
                    <p style={{color:'red', fontSize:10, marginVertical:5}}> {firstnameerror}</p>
                    }
    
                    </div>
           
                   <div style={{display: 'flex', flexDirection:'column', gap:10, width:'49%', marginBottom:20, marginRight:20}}>
    
                    <TextField
                      id="lastname"
                      onChange={(e) => setLastname(e.target.value)}
                      value = {lastname}
                      placeholder="Enter Lastname"
                      style={{width:'100%'}}
                    />
    
                    {lastnameerror &&
                    <p style={{color:'red', fontSize:10, marginVertical:5}}> {lastnameerror}</p>
                    }
    
                   </div>
                 
                  
                  <div style={{display: 'flex', flexDirection:'column', gap:10, width:'49%', marginBottom:20}}>
    
                      <TextField
                      id="telephone"
                      onChange={(e) => setTelephone(e.target.value)}
                      value = {telephone}
                      placeholder="+2348139444402"
                      style={{width:'100%'}}
                    />
    
                      {telephoneerror &&
                      <p style={{color:'red', fontSize:10, marginVertical:5}}> {telephoneerror}</p>
                      }
    
    
                  </div>
    
             
                  <div style={{display: 'flex', flexDirection:'column', gap:10, width:'49%', marginBottom:20, marginRight:20}}>
    
                  <Box sx={{ minWidth: '100%' }}>
                  <FormControl fullWidth>
                  <InputLabel id="role" style={{color:'#999', fontWeight:300}}>Select Your Admin Role</InputLabel>
                  <Select
                    labelId="role"
                    id="role"
                    value={role}
                    label="role"
                    onChange={(e) => setRole(e.target.value)}
              
                  >
    
              
    
                {roles.map((item) => { 
    
                    return(
    
                      <MenuItem key={item.key} value={item.value}>
                      
                          {item.label}
                     
                      </MenuItem>
    
                    ) 
                  })} 
    
                </Select>
                </FormControl>
                </Box>
    
                   <span style={{color:'red', fontSize:10}}>{roleerror && roleerror}</span>
                  </div>
    
              
    
                    <Button 
                    onClick={handleUpdateAdmin}
                    // disabled={perc !== null && perc < 100}
                    style={{width:'100%', backgroundColor:'rgb(15, 31, 175)', paddingTop:10, paddingBottom:10, color:'white'}}>{isloading ? "...Loading": 'Update Admin'}
                    </Button>
                </div>
                </div>
              </div>
            </div>
          </div>
 
  )
}

export default Edit